import { render, staticRenderFns } from "./single-staff.vue?vue&type=template&id=179ea858&scoped=true"
import script from "./single-staff.vue?vue&type=script&lang=js"
export * from "./single-staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ea858",
  null
  
)

export default component.exports